export default __webpack_public_path__ + "static/media/G0005.501bdbe8.png";